import Image from '@klv/atoms/image';
import KlaviyoFormAtom from '@klv/atoms/klaviyo-form';

import * as s from './styles';

import type { IFormsCta } from './types';

const FormsCta = ({ formId, backgroundColor = 'light', image }: IFormsCta) => {
  const hasImage = !!image?.gatsbyImage;

  return (
    <s.StyledFormsCta $backgroundColor={backgroundColor}>
      <s.ContentWrapper>
        {hasImage && image?.gatsbyImage && (
        <s.ImageWrapper>
          <Image altText={image.altText} imageData={image.gatsbyImage} />
        </s.ImageWrapper>
        )}
        <s.StyledFormWrapper hasImage={hasImage}>
          <KlaviyoFormAtom formId={formId} />
        </s.StyledFormWrapper>
      </s.ContentWrapper>
    </s.StyledFormsCta>
  );
};

export default FormsCta;
